var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:{ hide: !_vm.isVisible }},[_c('div',{staticStyle:{"min-width":"320px","min-height":"50px"},attrs:{"id":"div-gpt-ad-1681278828371-0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }